import { Types } from "../actionTypes"

import {
  setLog,
  types as errorTypes
} from '../../common/utilities/LogError'

const setLoading = loading => {
  return function (dispatch) {
    dispatch({
      type: Types.SET_BACKDROP_LOADING,
      payload: { loading }
    })
  }
}

const defaultSuccess = r => {
  return function (dispatch) {
    setLoading(false)(dispatch)
    return r
  }
}

const defaultCatch = (error, history) => {
  return function (dispatch) {
    setLoading(false)
    if (error?.response?.status === 401) logout(history)(dispatch)
    else if (error.message === "Network Error") logout(history)(dispatch)
    else if (error.response) {
      setLog({
        title: error.response.status,
        type: errorTypes.API_ERROR,
        message: error.response.data.errors,
        api_url: error.response.config.url,
        api_method: error.response.config.method,
        api_params: error.response.config.data
      })
    } else setLog({ type: errorTypes.API_ERROR, message: error.message })
  }
}
const setSnackbar = payload => {
  return function (dispatch) {
    dispatch({
      type: Types.SET_SNACKBAR_DATA,
      payload
    })
  }
}

const logout = history => {
  return function (dispatch) {
    dispatch({ type: Types.CLEAN_AUTH })
    history('/login')
  }
}

export {
  logout,
  defaultSuccess,
  defaultCatch,
  setLoading,
  setSnackbar
}